import { DataGrid } from '@tableau/data-grid-3-wrapper';
import * as React from 'react';
import { ServiceLocator } from '../../../../app/ServiceLocator';
import { Messages } from '../../../../codegen/Localize';
import { SortableDataGrid } from '../../../../common/react/components/dataGrid/SortableDataGrid3';
import { SortableHeader } from '../../../../common/react/components/dataGrid/SortableHeader';
import { DataRoleSingleValue } from '../../../../ts/ServerApi/types/IDataRole';
import { IOrderClause } from '../../../../ts/ServerApi/types/IOrderClause';
import { SliceableFactory } from '../../../../ts/services/SliceableFactory';
import { highlightSearchTextCellFormatter } from '../../../utils/highlightSearchTextCellFormatter';
import { formatValue, matchesSearch } from '../../../utils/searchUtils';


export interface LegacyDataRoleValuesListProps {
  readonly valuesList: ReadonlyArray<DataRoleSingleValue>;
  readonly isEditing: boolean;
  readonly filterText: string;
}

export const LegacyDataRoleValuesList = (props:LegacyDataRoleValuesListProps) => {
  const sliceableFactory: SliceableFactory = React.useMemo(() => ServiceLocator.get<SliceableFactory>('SliceableFactory'), []);
  const filteredValues = props.valuesList.filter(v => matchesSearch(v, props.filterText));

  const filteredSortedValues = (orderClause: ReadonlyArray<IOrderClause>):  ReadonlyArray<DataRoleSingleValue> => {
    if(orderClause.length < 1 || orderClause[0].ascending) {
      return filteredValues;
    }
    return [...filteredValues].reverse();
  };

  const dataGridCols = [
    {
      ...dataGridBaseCol,
      headerText: Messages.dataRoleDefinitionSubspace_Values_Name(),
      cellFormatter: highlightSearchTextCellFormatter(props.filterText),
    }
  ];

  return (
    <SortableDataGrid
      columns={dataGridCols}
      getSliceable={getRowData(sliceableFactory, (orderClause: ReadonlyArray<IOrderClause>) => filteredSortedValues(orderClause).map(formatValue))}
      getRowFromData={getRowFromData}
    />);
};

const getRowData = (sliceableFactory: SliceableFactory, getValueArray: (orderClause: ReadonlyArray<IOrderClause>) => ReadonlyArray<string>) =>
  (orderClause: ReadonlyArray<IOrderClause>) => sliceableFactory.fromArray([...getValueArray(orderClause)]);

const getRowFromData = (value: string)=> ({key: value, data: {name: value}});

const dataGridBaseCol = {
  name: 'name',
  dataKey: 'name',
  sortable: true,
  resizable: false,
  growToFit: true,
  headerFormatter: SortableHeader.Formatter(),
  direction: 'asc',
};
